module.exports = __webpack_public_path__ + "static/media/video.632332f1.svg";